import { Injector } from '@angular/core';

export class LocatorService {
  static injector: Injector;
}
